import React from "react";

export const FeaturedBrand = () => {
  return (
    <>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/14/original-obagi_logo-105214.png"
          alt="prod"
        />
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/59/Skinc-014559.jpg"
          alt="prod"
        />
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/34/original-220322-ELTAMD-LOGO-RGB-01_%28002%29-014534.png"
          alt="prod"
        />
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/09/Chantecaille-033909.png"
          alt="prod"
        />
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/08/SkinMedica-014608.jpg"
          alt="prod"
        />
      </div>
      <div>
        <img
          src="https://static.thcdn.com/images/small/webp/widgets/208-us/21/augustinusbader-124221.gif"
          alt="prod"
        />
      </div>
    </>
  );
};
